import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './showcase/Reveal';
import { ReviveVignette } from './showcase/ReviveVignette';
import { BrandButton } from './BrandButton';
const tiles: {
  value: string;
  label: string;
}[] = [{
  value: '48%',
  label: 'of leads never get a second touch. That is your database.'
}, {
  value: '5+ touches',
  label: 'is what 80% of closings take. Nobody has time to do that manually. The AI does.'
}, {
  value: 'Warm beats cold',
  label: 'a lead who already raised their hand converts at a multiple of any cold list your agents could dial.'
}];
export function DatabaseWakeUp() {
  return <section id="reactivation" aria-labelledby="reactivation-title" className="border-b border-white/5 bg-ink-800" data-id="element-62" data-mp="3mqtn4qqx6c2c">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-63" data-mp="o3fkoy4rl50w">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-64" data-mp="j9l8sgvehucd">
          <Reveal data-id="element-65" data-mp="1pxf51zadz4vk">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-66" data-mp="1pwvy1dm9y0wb">
              Database Reactivation
            </p>
            <h2 id="reactivation-title" className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-67" data-mp="1h4290oh0zn59">
              Thousands of leads are already sitting in your CRM. We wake them up.
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-white/65" data-id="element-68" data-mp="1c4pjfvyrs1yz">
              Every lead you paid for and never converted is still in there. We re-engage
              your stale database with AI voice and text, recirculate thousands of
              contacts, surface the ones still in market, and connect your agents with
              engaged prospects instead of hours of cold outreach through dead lists. It is
              handled for you.
            </p>
          </Reveal>

          <Reveal delay={0.08} data-id="element-69" data-mp="9c3iufu8kvvc">
            <ReviveVignette data-id="element-70" data-mp="9cd9m5n3v723" />
          </Reveal>
        </div>

        <dl className="mt-14 grid gap-5 md:grid-cols-3" data-id="element-71" data-mp="4d0deuacgnmu">
          {tiles.map((tile, index) => <Reveal key={tile.value} delay={0.06 * index} data-id="element-72" data-mp="bf4tl4uevig" data-mpi={index}>
              <div className="h-full rounded-xl border border-white/10 bg-ink-700 p-7" data-id="element-73" data-mp="bynj42bhnxj">
                <dt className="font-display text-2xl font-bold leading-tight tracking-tight text-brand" data-id="element-74" data-mp="3rj1epvi5nu7r">
                  {tile.value}
                </dt>
                <dd className="mt-4 text-sm leading-relaxed text-white/60" data-id="element-75" data-mp="o19gw0hc8g1n">
                  {tile.label}
                </dd>
              </div>
            </Reveal>)}
        </dl>

        <Reveal className="mt-12 flex flex-col items-start gap-5 sm:flex-row sm:items-center sm:gap-8" data-id="element-76" data-mp="eb7t79swczn9">
          <BrandButton label="Book your free Response Audit" withArrow data-id="element-77" data-mp="1bqlq30co0o3y" />
          <Link to="/who-its-for" className="group inline-flex items-center gap-2 rounded text-sm font-semibold text-brand transition-colors hover:text-brand-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-78" data-mp="1bsomc24evdh4">
            Read: the leads you already own
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-79" data-mp="1jbxvpvcx3c66" />
          </Link>
        </Reveal>
      </div>
    </section>;
}